<template>
    <div class="betContent">
        <!-- 17是ob_sport的串關 ob_sport沒有單場串關 -->
        <!-- 19是im_sport的串關 im_sport沒有單場串關 -->
        <!-- 21是ai_sport的串關 ai_sport沒有單場串關 -->
        <!-- 29是ia_esport的串關 ai_sport沒有單場串關 -->
        <template v-if="row.content_type == 4" >
            <template>
                <span style="color: black; font-weight:bold;">{{ $t("column.saba.parlay_single") }}</span><br>
            </template>

            <span class="text-saba">{{ row["sport_name"] }}</span><br />

            <template  v-if="row.competition != '' ">
                <span>[{{ row['competition'] }}]</span><br>
            </template>

            <template  v-if="row.team1 && row.team1 != ''">
                <span  ><i class="tg-icon tg-icon-grayball"></i>{{ row["team1"] }}</span><br>
            </template>
            
            <template  v-if="row.team2 && row.team2 != ''">
                <span  ><i class="tg-icon tg-icon-grayball"></i>{{ row["team2"] }}</span><br>
            </template>

            <template v-if="showBr">
                <el-row type="flex" justify="center" align="middle">
                    <i class="tg-icon tg-icon-game"></i>
                    <span class="text-green"
                        >{{ row["market"] }} {{ row["selection"] }}</span
                    >
                </el-row>
                <div>
                    <span class="text-green">{{ row["profit_type_name"] }}</span>
                    <span>@</span>
                    <span class="text-red">{{ profitWtihNoIcon }}</span>
                </div>
            </template>
            <template v-else>
                <span class="text-green">{{ row["profit_type_name"] }}</span>
                <span>@</span>
                <span class="text-red">{{ profitWtihNoIcon }}</span>
            </template>

            <template>
                <div>
                    <span
                        class="as-link"
                        @click="handleSabaResultClick"
                        ><i class="tg-icon tg-icon-result"></i>{{ $t("column.result_after") }}
                    </span>
                </div>
            </template>
        </template>

        <template v-else >
            <template>
                <span style="color: black; font-weight:bold;">{{ $t("column.saba.parlay") }}</span><br />
            </template>
            <template v-for="(item,index) in row.parlay_items">
                <span :key="index" v-if="item['stake']">{{ item['combo_type'] }}({{item['bet_num']}}{{$t("column.bets")}}) x RMB {{ decimal(item['stake']) }}</span>
                <span :key="index" v-else >{{ item['combo_type'] }}({{item['bet_num']}}{{$t("column.bets")}})</span><br :key="index" />
            </template>
            <div>
                <template style="width=50%;">
                    <span
                        class="as-link"
                        @click="handleSabaDetailClick"
                        ><i class="tg-icon tg-icon-detail"></i>{{ $t("column.detail") }}
                    </span>
                </template>
                
                <template style="width=50%;">
                    <span
                        class="as-link"
                        @click="handleSabaResultClick"
                        ><i class="tg-icon tg-icon-result"></i>{{ $t("column.result_after") }}
                    </span>
                </template>
            </div>
        </template>
        
    </div>
</template>

<script>
import formatter from "@/utils/formatter";

export default {
    props: {
        row: Object,
    },
    methods:{
        handleSabaDetailClick() {
            this.row.dialog_type = "detail";
            this.$emit("on-click");
        },
        handleSabaResultClick() {
            this.row.dialog_type = "result";
             this.$emit("on-click");
        },
        decimal(value){
            return formatter.format(value, "percentWithNoIcon");
        }
    },
    computed: {
        profitWtihNoIcon() {
            return formatter.format(this.row["profit"], "percentWithNoIcon");
        },
        showBr() {
            return this.row['selection'] && this.row['selection'].length > 6;
        },
    },
};
</script>
